import { unescapeString } from './string';
export function splitPath(dataPath, noThrow) {
    const ans = [];
    let path = String(dataPath);
    let expectDot = false;
    while (path) {
        let mat;
        if ((mat = /^\s+/.exec(path))) {
            // 空格
        }
        else if ((mat = /^\[\s*("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|-?\d+)\s*\]/.exec(path))) {
            // 匹配 ["foo.bar"] 和 [0] 这种
            const p = mat[1];
            if (p[0] === '"' || p[0] === '\'') {
                // is string
                ans.push(unescapeString(p.slice(1, -1)));
            }
            else {
                // is index number
                const n = parseInt(p, 10);
                if (isNaN(n))
                    throw new Error(`Invalid index number: ${path}`);
                ans.push(String(n));
            }
            expectDot = true;
        }
        else if (expectDot && (mat = /^\??\./.exec(path))) {
            expectDot = false;
        }
        else if (!expectDot && (mat = /^[^[\]\s.]+/.exec(path))) {
            // 匹配一般的格式（非 [ 开头，且不含 . ）（规则比较宽松）
            ans.push(mat[0]);
            expectDot = true;
        }
        else {
            // 出现错误
            if (noThrow)
                return null;
            throw new Error(`Unknown remainder: ${path}`);
        }
        path = path.slice(mat[0].length);
    }
    return ans;
}
export function joinPath(parts) {
    let ans = parts
        .map((x) => {
        if (!Number.isNaN(+x))
            return `[${x}]`;
        if (!x)
            return '';
        if (/^[a-zA-Z\d_$][\w$]*$/.test(x))
            return `.${x}`;
        return `[${JSON.stringify(String(x))}]`;
    })
        .join('');
    if (ans.charAt(0) === '.')
        ans = ans.substr(1);
    return ans;
}
export function toPathParts(input) {
    if (typeof input === 'number')
        return [String(input)];
    if (Array.isArray(input))
        return Array.from(input, x => String(x));
    return splitPath(input);
}
